import { Device, DeviceLoanPatient } from '../interfaces/Device';

export const getLastLoan = (loans: DeviceLoanPatient[] | undefined) => loans && loans.length > 0 ? loans[0] : null;

export const isDeviceOnLoan = (device: Device) => {
    return (getLastLoan(device.loans)?.return_date === null);
};